module.exports = __webpack_public_path__ + "LatoLatin-SemiboldItalic.70354df963e55623f6ea.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-SemiboldItalic.eot
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-SemiboldItalic.eot
// module chunks = styles